import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../../Components/Layout";
import PaymentRefund from "../../../Components/OrderMgt/PaymentRefund/PaymentRefund";
import useHttpHook from "../../../Hooks/HttpHook";
import { GetCancelRequest } from "../../../utils/ApiConstant";
import { OrderLanguage } from "../../../utils/Languages";

const PaymentRefundPage = () => {
  const { ticketId, orderId } = useParams();
  const [loading, sendRequest, error] = useHttpHook();
  const [details, setDetails] = useState(null);
  const query = new URLSearchParams(window.location.search);

  const redirectUrl = query.get("redirectUrl");

  useEffect(() => {
    getTicketDetails();
  }, []);

  const getTicketDetails = async () => {
    try {
      let response = await sendRequest(`${GetCancelRequest}/${orderId}`, {
        method: "get",
      });
      setDetails(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout
      Heading={OrderLanguage.PaymentRedund.heading}
      TitleMark={true}
      TitleMarkClassName="event-order-detail-title-mark"
      TitleClassName="event-order-detail-title"
      HeadClassName="event-order-detail-head"
      DetailsHead
      ExtraclassName="event-payment-refund-panel"
      activeMenuId="orders"
      BackAction={
        // userDetails && page === "myevents" ? "/organizer/MyEvents" : "/"
        redirectUrl || -2
      }
    >
      <PaymentRefund
        isLoading={loading}
        isError={error}
        details={details}
        getDetails={getTicketDetails}
      />
    </Layout>
  );
};

export default PaymentRefundPage;
